// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloudUploadFilledSvg from "@fishx/icons-svg/es/asn/CloudUploadFilled";
import FishxIcon from '../components/FishxIcon';

var CloudUploadFilled = function CloudUploadFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloudUploadFilledSvg
  }));
};

CloudUploadFilled.displayName = 'CloudUploadFilled';
export default React.forwardRef(CloudUploadFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CloudUploadFilled.js
// module id = 2255
// module chunks = 0